// Non-blocking messages, replacing window.alert() (systems review 2026-09-30:
// 121 blocking alert() calls). An alert() stops the whole page until it's
// dismissed and on a phone looks like the browser itself is complaining.
//
//   toast.error('Certify failed: …')    stays 8 s (or until dismissed)
//   toast.success('Week reopened.')      stays 5 s
//   toast.info(longSummary)              multi-line or long text stays until dismissed
//
// <ToastHost/> (mounted once at the root, src/app.jsx) renders them.

let nextId = 1;
let items = [];
const listeners = new Set();

function emit() { for (const l of listeners) l(items); }

function dismiss(id) {
  items = items.filter((t) => t.id !== id);
  emit();
}

function show(message, kind = 'info', opts = {}) {
  const text = String(message ?? '');
  const sticky = opts.sticky ?? (text.includes('\n') || text.length > 140);
  const t = { id: nextId++, text, kind };
  items = [...items.slice(-4), t];   // at most 5 on screen
  emit();
  if (!sticky) setTimeout(() => dismiss(t.id), kind === 'error' ? 8000 : 5000);
  return t.id;
}

export const toast = {
  info: (m, o) => show(m, 'info', o),
  success: (m, o) => show(m, 'success', o),
  error: (m, o) => show(m, 'error', o),
  dismiss,
  subscribe(fn) { listeners.add(fn); fn(items); return () => listeners.delete(fn); },
};

// Error text from a thrown value, for `catch (e) { toast.error(errText(e, 'Save failed')) }`.
export function errText(e, fallback = 'Something went wrong') {
  return (e && (e.message || (typeof e === 'string' ? e : ''))) || fallback;
}
